module.exports = __webpack_public_path__ + "img/18.60865500.jpg";